export enum SmsSubscriptionOption {
  NONE = 'NONE',
  SIMPLE = 'SIMPLE',
  DOUBLE = 'DOUBLE',
}
